import React from "react";
import "./VipTag.css";

const VipTag = (props) => {
  if (!props.show) return null;
  return <span className="VipTag">VIP</span>
}

VipTag.defaultProps = {
  show: false
}

export default VipTag;
